import {Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild} from '@angular/core';
import {FormGroup, FormControl, Validators} from '@angular/forms';
import {ParkAttributesInterface} from '@app/app/shared/interfaces/park-attributes.interface';
import {HttpClient} from '@angular/common/http';
import {ParkInterface} from '@app/app/shared/interfaces/park.interface';
import {Serialize} from '@app/app/shared/helpers/serialize.helper';
import {MapsAPILoader} from '@agm/core';
import {UrlHelper} from '@app/app/shared/helpers/url.helper';
import {CommandsService} from '@app/app/shared/services/commands.service';

@Component({
  templateUrl: './park-info-form.html',
  selector: 'park-info-form'
})
export class ParkInfoFormComponent implements OnInit {
  @Input() attributes: ParkAttributesInterface;
  @Input() park: ParkInterface;
  @Input() getSearchStatus: boolean;
  @Output() getSearchStatusChange = new EventEmitter<boolean>();
  public infoForm: FormGroup;
  public inProgress = false;
  @ViewChild('addressAutocomplete') public addressAutocompleteEl: ElementRef;

  public installationTypes = [{id: 'FT', label: 'FT'}, {id: 'WQMS', label: 'WQMS'}, {id: 'WR', label: 'WR'}];

  constructor(private comm: CommandsService, private http: HttpClient,
              private mapsAPILoader: MapsAPILoader, private ngZone: NgZone, private urlHelper: UrlHelper) {
    this.infoForm = new FormGroup({
      name: new FormControl('', [Validators.required, Validators.minLength(5)]),
      address: new FormControl('', [Validators.required, Validators.minLength(10)]),
      installation_type: new FormControl('', [Validators.required, Validators.minLength(1)]),
    });
  }

  public setEditMode() {
    this.getSearchStatusChange.emit(false);
  }

  onSubmit({value, valid}) {
    if (valid) {
      this.inProgress = true;

      const url = `${this.urlHelper.getPrefix()}/parks/${this.park.id}`;

      const body = {
        data: {
          type: 'Parks',
          attributes: {
            name: value.name,
            address: value.address,
            installation_type: value.installation_type,
            project_id: this.attributes.projectId,
            iccid: this.attributes.iccid,
          }
        }
      };

      this.http.put(url, body).subscribe((res: { data: { attributes: ParkAttributesInterface } }) => {
        this.inProgress = false;
        Object.assign(this.park.attributes, Serialize.snakeToCamel(res.data.attributes));
        this.setEditMode();

        const settings = {timezone: res.data.attributes.location.timezone};
        this.comm.updateSettings(this.park.attributes.parkId, this.park.id, settings).then((res) => {
          //
        }).catch((err) => {
          // console.log(err);
        });
      }, (err) => {
        this.inProgress = false;
      }, () => {
        this.inProgress = false;
      });
    }
  }

  ngOnInit() {
    this.infoForm.setValue({
      name: this.attributes.name,
      address: this.attributes.location.address,
      installation_type: this.attributes.installationType,
    });

    // load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(this.addressAutocompleteEl.nativeElement, {
        types: ['address']
      });

      autocomplete.addListener('place_changed', () => {
        this.ngZone.run(() => {
          // get the place result
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();

          if (place.formatted_address === undefined || place.formatted_address === null) {
            return;
          }

          this.infoForm.patchValue({
            address: place.formatted_address,
          });
        });
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/forms/park-info-form/park-info-form.component.ts